/**
=========================================================
* Iris Design Limited  Fulfilment POD - v2.2.0
=========================================================

* Product Page: https://www.irisdesignlimited.com/product/material-dashboard-react
* Copyright 2023 Dev Iris Design Limited Company (https://www.irisdesignlimited.com)

Coded by www.irisdesignlimited.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Iris Design Limited  Fulfilment POD base styles
import borders from "assets/theme/base/borders";

// Iris Design Limited  Fulfilment POD helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { borderRadius } = borders;

const tableHead = {
  styleOverrides: {
    root: {
      display: "block",
      padding: `${pxToRem(16)} ${pxToRem(16)} 0  ${pxToRem(16)}`,
      borderRadius: `${borderRadius.xl} ${borderRadius.xl} 0 0`,
    },
  },
};

export default tableHead;
